module.exports = __webpack_public_path__ + "img/1_036.a58df2aa.jpg";